<template>
  <div style="margin-top:30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px" :disabled="detailType=='details'">
      <el-form-item label="合同编号" prop="serialNum" style="margin-right:15px">
        <el-input v-model="form.serialNum" placeholder="请输入合同编号" />
      </el-form-item>
      <el-form-item label="签订时间" prop="signTime" style="margin-right:15px">
        <el-date-picker v-model="form.signTime" :clearable="false" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="请输入签订时间" />
      </el-form-item>
      <el-form-item v-if="detailType!='details'" label="附件" prop="fileUrl" style="margin-right:15px">
        <el-upload
          :headers="headers"
          class="upload-demo"
          accept=".pdf,.PDF,.doc,.docx,.jpg,.jpeg,.bmp,.png"
          :multiple="true"
          :on-success="uploadSuccess"
          :on-remove="fileRemove"
          :action="fileUploadUrl"
          :file-list="fileList"
          :before-upload="beforeUploadFile"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传pdf/doc/docx/jpg/jpeg/bmp/png文件</div>
        </el-upload>
      </el-form-item>
      <el-form-item v-if="detailType=='details'" label="附件地址" style="margin-right:15px">
        <template v-for="(v,k) in fileList">
          <div :key="k">
            <el-link target="_blank" type="primary" icon="el-icon-paperclip" :href="v.url">{{ v.name }}</el-link>
          </div>
        </template>
      </el-form-item>
    </el-form>
    <div v-if="detailType!='details'" slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">取 消</el-button>
      <el-button type="primary" @click="funcSubmit">确 定</el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import { getToken } from '@/utils/auth';
export default {
  name: "ShipmentContractAdd",
  data() {
    return {
      detailType: "add",
      fileUploadUrl: this.BASE_API_URL + "ntocc-tps-api/fileUpload",
      headers: {
        Authorization: "Bearer " + getToken(),
        deviceId: "0000000000",
      },
      fileList: [],
      form: {
        partyCode: "",
        serialNum: "",
        signTime: "",
        fileUrl: ""
      },
      rules: {
        serialNum: [
          { required: true, message: "请输入合同编号", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 100 个字符",
            trigger: "blur",
          },
        ],
        signTime: [
          { required: true, message: "请选择签订时间", trigger: "blur" },
        ],
        fileUrl: [{ required: true, message: "请上传合同", trigger: "change" }],
      },
    };
  },
  created() {
    this.form.partyCode = this.$route.query.partyCode
      ? this.$route.query.partyCode
      : "";
  },
  methods: {
    // 获取页面信息
    getInfo(detailType, code) {
      this.detailType = detailType;
      this.$refs["form"].clearValidate();
      this.form.serialNum = ""
      this.form.signTime = ""
      this.form.fileUrl = ""
      this.fileList = [];
      if (code) {
        request({
          url: `/ntocc-basic-api/shipmentContract/${code}`,
          method: "get",
        }).then((response) => {
          this.form = response.data;
          if (this.form.fileUrl) {
            this.fileList = JSON.parse(this.form.fileUrl);
          }
        });
      }
    },
    //提交
    funcSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const data = this.form;
          const files = [];
          const rLoading = this.openLoading();
          if (this.fileList.length > 0) {
            for (let i in this.fileList) {
              const file = this.fileList[i];
              if (file.url) {
                files.push(file);
              } else if (file.response && file.response.data) {
                files.push({ name: file.name, url: file.response.data });
              }
            }
          }
          let method = this.detailType=='add'?'post':'put'
          data.fileUrl = JSON.stringify(files);
          request({
            url: "/ntocc-basic-api/shipmentContract",
            method: method,
            params: data,
          })
            .then((response) => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherAddMethod");
            })
            .then(() => this.$refs["form"].resetFields(), (this.fileList = []));
        } else {
          return false;
        }
      });
    },
    //上传前校验
    beforeUploadFile(file) {
      this.headers.Authorization = 'Bearer ' + getToken()
      return true
    },
    //文件上传成功回调方法
    uploadSuccess(response, file, fileList) {
      if (response.status === 0) {
        this.fileList.push(file);
        this.form.fileUrl = JSON.stringify(fileList);
      } else {
        for (let i in fileList) {
          if (fileList[i].uid == file.uid) {
            fileList.splice(i, 1);
          }
        }
        this.$message({ message: response.msg, type: "error" });
      }
    },
    //文件移除回调方法
    fileRemove(file, fileList) {
      this.fileList = fileList;
      this.form.fileUrl = JSON.stringify(fileList);
    },
    //取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "add");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
